import { posthog } from 'posthog-js';
import { AnalyticsUserProperties, AnalyticsEventName, AnalyticsProperties } from './types';

// Identify a user in PostHog
export function identifyUser(userId: string, properties?: AnalyticsUserProperties) {
  console.debug('analytics:identifyUser', userId, properties);
  posthog.identify(userId, properties);
}

// Track person properties
export function trackPersonProperties(properties: AnalyticsProperties) {
  console.debug('analytics:trackPersonProperties', properties);
  posthog.setPersonProperties(properties);
}

// Alias an anonymous user to a permanent user in PostHog
export function aliasUser(newId: string, oldId: string) {
  console.debug('analytics:aliasUser', newId, oldId);
  posthog.alias(newId, oldId);
}

// Track an event in PostHog
export function trackEvent(event: AnalyticsEventName, properties?: AnalyticsProperties) {
  console.debug('analytics:trackEvent', event, properties);
  posthog.capture(event, properties);
}

// Track a group
export function trackGroup(groupType: 'network', groupId: string, properties?: AnalyticsProperties) {
  console.debug('analytics:trackGroup', groupType, groupId, properties);
  posthog.group(groupType, groupId, properties);
}
